import React from "react";
import {
  Row,
  Col,
  Collapse,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardSubtitle,
  Table,
  Button,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import NumberFormat from "react-number-format";
import moment from "moment";

class InvoiceItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false };
  }

  toggleIsExpanded = () => {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  };

  rePostOrderInFortNox = (orderId) => {
    axios
      .post(`/ShopNew/RePostFailedFortNoxOrder?orderId=${orderId}`)
      .then((res) => {
        if (res.data.result.postWasSuccessful) {
          toast.success(
            "Order '" +
              res.data.result.id +
              "' fick ordernummer '" +
              res.data.result.fortNoxOrderNumber +
              "'"
          );

          document.getElementById("button" + orderId).style.display = "none";
          document.getElementById("td" + orderId).innerHTML =
            res.data.result.fortNoxOrderNumber;
        } else {
          toast.warn(res.data.result.failMessage);
        }
      })
      .catch((err) => {
        toast.warn(err.response ? err.response.data : err.message);
      });
  };

  getOrderRows = () => {
    let rows = [];
    let index = 0;

    this.props.invoice.products.forEach((product) => {
      let isProgram = product.programLicense !== null;
      rows.push(
        <tr key={index++}>
          <td>
            {isProgram ? (
              <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Package" />
            ) : (
              <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Course" />
            )}
          </td>
          <td>
            {isProgram ? product.programLicense.name : product.course.name}
            {isProgram ? (
              <span>
                <br />
                {product.programLicense.packageName}
              </span>
            ) : (
              ""
            )}
          </td>
          <td>
            {product.students.length > 0
              ? `${product.price / product.students.length} SEK`
              : `${product.price} SEK`}
          </td>
          <td>
            {product.students.length > 0
              ? `${product.students.length} st`
              : "1 st"}
          </td>
          <td>{product.price} SEK</td>
        </tr>
      );
      if (isProgram) {
        product.programLicense.courses.forEach((course) => {
          rows.push(
            <tr key={index++}>
              <td>
                <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Course" />
              </td>
              <td>{course.name}</td>
              <td>
                <em>
                  <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.IncludedIn" />
                  {" " + product.programLicense.name}
                </em>
              </td>
              <td>{product.students.length} st</td>
              <td>-</td>
            </tr>
          );
        });
      }
    });

    return rows;
  };

  render() {
    return (
      <Row>
        <Col sm="6" md="10">
          <Card>
            <CardHeader>
              {this.props.fortNoxDisplay &&
              this.props.invoice.fortNoxErrorMessage !== null ? (
                <div
                  className="float-end"
                  title={this.props.invoice.fortNoxErrorMessage}
                >
                  <span className="fa fa-warning fa-2x text-danger" />
                </div>
              ) : (
                <span />
              )}
              <CardTitle
                className="justify-center"
                style={{ fontSize: "1.2em" }}
              >
                <Table>
                  <tbody>
                    <tr>
                      <td width="400px">
                        <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.OrderNumber" />
                      </td>
                      <td id={"td" + this.props.invoice.id}>
                        {this.props.invoice.rePostIsAllowed ? (
                          <Button
                            color="primary"
                            outline
                            type="button"
                            onClick={() => {
                              this.rePostOrderInFortNox(this.props.invoice.id);
                            }}
                            id={"button" + this.props.invoice.id}
                          >
                            RePost
                          </Button>
                        ) : (
                          this.props.invoice.fortNoxNumber
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Customer" />
                      </td>
                      <td>{this.props.invoice.createdBy}</td>
                    </tr>
                    <tr>
                      <td>
                        <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.CustomerName" />{" "}
                      </td>
                      <td>
                        {this.props.invoice.school.name +
                          " - " +
                          this.props.invoice.school.fortKnoxCustomerNumber}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardTitle>
              <CardSubtitle>
                &nbsp;&nbsp;&nbsp;
                <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Date" />{" "}
                {moment(this.props.invoice.created).format("YYYY-MM-DD")}
                {", "}
                <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.TotalPrice" />{" "}
                <NumberFormat
                  value={this.props.invoice.price}
                  displayType={"text"}
                  thousandSeparator={" "}
                />{" "}
                SEK,&nbsp;
                <FormattedMessage id="Id" /> {this.props.invoice.id}{" "}
                &nbsp;&nbsp;
                <span
                  style={{ cursor: "pointer" }}
                  className="text-primary"
                  onClick={this.toggleIsExpanded}
                >
                  {this.state.isExpanded ? (
                    <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.HideInvoice" />
                  ) : (
                    <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.ShowInvoice" />
                  )}
                </span>
              </CardSubtitle>
            </CardHeader>
            <Collapse isOpen={this.state.isExpanded}>
              <CardBody>
                {this.getOrderRows().length > 0 && (
                  <div>
                    <CardTitle>
                      <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.PackagesAndCourses" />
                    </CardTitle>
                    <Table responsive striped size="sm">
                      <thead>
                        <tr>
                          <th width="10%">
                            <FormattedMessage id="Type" />
                          </th>
                          <th width="40%">
                            <FormattedMessage id="Name" />
                          </th>
                          <th width="30%">
                            <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.ProductIndividualPrice" />
                          </th>
                          <th width="10%">
                            <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Amount" />
                          </th>
                          <th width="10%">
                            <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.ProductTotalPrice" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>{this.getOrderRows()}</tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
              {this.props.invoice.comment && (
                <CardBody>
                  <CardTitle>
                    <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Comment" />
                  </CardTitle>
                  <CardSubtitle>{this.props.invoice.comment}</CardSubtitle>
                </CardBody>
              )}
            </Collapse>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default InvoiceItem;
